/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedAffirm_item = {|
  +affirmDisplayInfo: ?{|
    +showAffirmPromo: ?boolean;
  |};
  +pdpTypeDisplay: ?"DEFAULT" | "UNPURCHASABLE" | "NOT_LISTED";
  +pricing: ?{|
    +totalAmount: ?{|
      +convertedAmounts: ?{|
        +USD: ?number;
      |};
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAffirm_item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "affirmDisplayInfo",
      "args": null,
      "concreteType": "ItemDisplayInfo",
      "name": "displayInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "showAffirmPromo",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pdpTypeDisplay",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemPricing",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "name": "totalAmount",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmounts",
              "name": "convertedAmounts",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "USD",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
